export const hideHeader = () => {
	const header = document.querySelector('header.main-navigation.yacht-new');

	if(header.classList.contains('_is-visible')){
		header.classList.remove('_is-visible');
		document.body.classList.remove('_has-visible-header');
	}
};
